// @flow
import Form from "@fas/ui-core/lib/Form";
import withForm from "@fas/ui-framework/lib/services/form";

export default withForm(Form);
